module.exports = __webpack_public_path__ + "static/img/18.c4138d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/18.png
// module id = yNmG
// module chunks = 0